import request from "root/js/request";

export const getProductCardPromotionHeatMap = async ({
  cabinet_id,
  date_from,
  date_to,
  period,
  in_product_id,
  in_product_id__in,
  extra_fields,
  source,
  source__in,
  filter_by_advert_stat,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/card_advert_heat_map/",
    method: "get",
    params: {
      cabinet_id,
      date_from,
      date_to,
      period,
      in_product_id,
      in_product_id__in,
      extra_fields,
      source,
      source__in,
      filter_by_advert_stat,
      ...rest,
    },
  });
  return response.data;
};
